import { motion } from 'framer-motion';
import { useRef } from 'react';
import { useInView } from 'framer-motion';

const Advantages = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  const fadeInVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 1.5 } },
  };

  return (
    <section ref={ref} className="padding w-full py-12 bg-white">
      <div className="container mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-4xl font-bold text-blue-600">Our Advantages</h2>
          <p className="mt-4 text-lg text-gray-700">
            Why students choose us for their education and success.
          </p>
        </div>
        <motion.div
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.2, // Stagger fade for each card
              },
            },
          }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {/* Advantage 1 */}
          <motion.div
            variants={fadeInVariants}
            className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div className="text-blue-600 text-5xl mb-4">
              <i className="fas fa-user-graduate"></i>
            </div>
            <h3 className="text-2xl font-bold mb-2">Expert Faculty</h3>
            <p>
              Learn from highly qualified and experienced educators dedicated to your academic success.
            </p>
          </motion.div>

          {/* Advantage 2 */}
          <motion.div
            variants={fadeInVariants}
            className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div className="text-blue-600 text-5xl mb-4">
              <i className="fas fa-chalkboard-teacher"></i>
            </div>
            <h3 className="text-2xl font-bold mb-2">Interactive Learning</h3>
            <p>
              Benefit from engaging and interactive learning sessions that make difficult concepts easy to grasp.
            </p>
          </motion.div>

          {/* Advantage 3 */}
          <motion.div
            variants={fadeInVariants}
            className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div className="text-blue-600 text-5xl mb-4">
              <i className="fas fa-book-reader"></i>
            </div>
            <h3 className="text-2xl font-bold mb-2">Comprehensive Study Material</h3>
            <p>
              Access our curated, in-depth study materials designed to complement classroom learning.
            </p>
          </motion.div>

          {/* Advantage 4 */}
          <motion.div
            variants={fadeInVariants}
            className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div className="text-blue-600 text-5xl mb-4">
              <i className="fas fa-medal"></i>
            </div>
            <h3 className="text-2xl font-bold mb-2">Proven Success Record</h3>
            <p>
              Join a community of students who have achieved academic excellence and success in their careers.
            </p>
          </motion.div>

          {/* Advantage 5 */}
          <motion.div
            variants={fadeInVariants}
            className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div className="text-blue-600 text-5xl mb-4">
              <i className="fas fa-globe"></i>
            </div>
            <h3 className="text-2xl font-bold mb-2">Global Exposure</h3>
            <p>
              Our curriculum includes global perspectives and prepares students for international opportunities.
            </p>
          </motion.div>

          {/* Advantage 6 */}
          <motion.div
            variants={fadeInVariants}
            className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div className="text-blue-600 text-5xl mb-4">
              <i className="fas fa-user-check"></i>
            </div>
            <h3 className="text-2xl font-bold mb-2">Personalized Mentorship</h3>
            <p>
              Receive personalized attention and mentorship from faculty to help you achieve your goals.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Advantages;
